import axios from 'axios'

export default class Api {
  constructor(apiKey) {
    this.apiKey = apiKey
  }

  getArticle = key => {
    var form = new FormData()
    form.append('api_key', this.apiKey)
    form.append('key', key)

    return axios({
      url: 'https://api.qliq.cloud/api/web/v1/articles/get-v2',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      responseType: 'json',
      data: form,
    })
  }

  listArticles = (limit = 10, offset = 0) => {
    var form = new FormData()
    form.append('api_key', this.apiKey)
    form.append('limit', limit)
    form.append('offset', offset)

    return axios({
      url: 'https://api.qliq.cloud/api/web/v1/articles/get-v2',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      responseType: 'json',
      data: form,
    })
  }
}



// WEBPACK FOOTER //
// ./src/api.js